<template>
	<div>
		<el-row>
			<el-col :lg="7" :md="9" :sm="12" :span="6" :xl="6" :xs="24">
				<img src="images/fgk-product.png" style="width: 100%" />
			</el-col>
			<el-col :lg="16" :md="14" :sm="12" :span="18" :xl="18" :xs="24">
				<div style="margin-left: 16px">
					<h2>太保电梯安装维保人员雇主险</h2>
					<div>行业超低价 | 中国太平洋承保 | 全线上操作</div>
					<p>
						① 电梯安装 | 维保人员 | 保额最高150万
						<br />
						② 社保用药100%赔付 | 扩展自费药
						<br />
						③ 3人起保 | 无安全带不拒赔 | 无高处作业证要求
					</p>
					<div>
						<el-button size="medium" type="warning" @click.native="handleInsure(0)">立即投保</el-button>
						<el-button size="medium" type="primary" @click.native="handleInsure(1)">投保计划书</el-button>
					</div>
					<br />
					<el-button
						:loading="isDownLoading"
						icon="el-icon-download"
						size="medium"
						style="margin-top: 5px"
						type="text"
						@click.native="handleDownLoad">
						下载太保职业类别表
					</el-button>
				</div>
			</el-col>
		</el-row>
		<el-tabs v-model="currentStep">
			<el-tab-pane label="保险详情" name="0">
				<el-card>
					<avue-crud
						ref="plan"
						:cell-style="onCellStyle"
						:data="dataPlan"
						:option="optionPlan"
						:span-method="spanMethodPlan"></avue-crud>
					<el-row style="margin-bottom: 10px; margin-top: 20px">
						<span>批增规则</span>
					</el-row>
					<avue-crud ref="add" :data="dataAddFeeRate" :option="optionAddFeeRate"></avue-crud>
				</el-card>
				<el-card header="赔付标准">
					<el-row justify="center" type="flex">
						<span style="font-weight: 500; color: Red; margin-bottom: 20px">
							社保用药范围100%赔付，伤残等级对应赔付比例请查看附表
						</span>
					</el-row>
					<avue-crud ref="crud" :cell-style="onCellStyleFit" :data="dataBenefit" :option="optionBenefit">
						<template slot="header"></template>
					</avue-crud>
				</el-card>
			</el-tab-pane>
			<el-tab-pane label="常见问题" name="1">
				<el-row>
					<el-col :span="20">
						<ul>
							<li v-for="{question, answer} in dataQA" :key="question">
								<div>
									<span
										style="
											display: inline-block;
											width: 20px;
											text-align: center;
											background-color: MediumPurple;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										Q
									</span>
									<span style="font-weight: bold">{{ question }}</span>
								</div>
								<p></p>
								<div>
									<span
										style="
											display: inline-block;
											width: 20px;
											background-color: MediumSeaGreen;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										A
									</span>
									<span v-if="question === '雇员变动怎么办？'">
										本产品批增按以下年单保费的比例进行收费：不足一个月按一个月收费，不可减人。
										<avue-crud :data="dataAddFeeRate" :option="optionAddFeeRate" style="padding: 10px"></avue-crud>
										保险期限1-3个月的保单不可换人，保险期限超过3个月的保单可以换人。替换时，电梯安装维保人员能替换为新的电梯安装维保人员，不分节假日，全天24小时，均可线上直接替换或新增人员。
									</span>
									<span v-else>{{ answer }}</span>
								</div>
								<el-divider></el-divider>
							</li>
						</ul>
					</el-col>
				</el-row>
			</el-tab-pane>
			<el-tab-pane label="投保须知" name="2">
				<el-row>
					<el-col :span="20">
						<h3>保险条款及须知</h3>
						<p style="line-height: 32px">
							1、 本保险适用以下保险条款
							<br />
							<span class="link">
								<a href="fgkclause.html" style="color: DodgerBlue" target="_blank">
									中国太平洋财产保险股份有限公司雇主责任保险条款
								</a>
							</span>
							2、本保险由中国太平洋财产保险股份有限公司承保，承保区域为全国范围（港澳台除外）。
							<br />
							3、保险公司设有省级分支机构和落地服务机构的省清单见如下链接：
							<br />
							<span class="link">
								<a
									href="http://property.cpic.com.cn/xccbx/gygs/fzjg/index.shtml?skip="
									style="color: DodgerBlue"
									target="_blank">
									省级分支机构和落地服务机构
								</a>
							</span>
							4、保险公司全国统一的客户服务及投诉方式详见如下链接：
							<br />
							<span class="link">
								<a
									href="http://property.cpic.com.cn/xccbx/gkxxbl/jbxx/gsgk/?subMenu=1&amp;inSub=1"
									style="color: DodgerBlue"
									target="_blank">
									全国统一的客户服务及投诉方式
								</a>
							</span>
							5、在投保本保险前请您认真阅读《
							<span class="red-bold">雇主责任</span>
							保险条款》，了解本保险的保险责任及责任免除，尤其是对其中免除保险人责任的条款（包括但不限于责任免除、
							<span class="red-bold">免赔额</span>
							、投保人被保险人义务等）。在充分理解并接受上述内容的基础上，同意以此作为订立保险合同的依据。
							<br />
							6、在投保本保险时您应如实填写各项投保信息以履行相应的如实告知义务，若故意或者因重大过失未履行如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同；故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费；因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，
							<span class="red-bold">但</span>
							退还保险费。
							<br />
							7、本保险合同以电子保单形式提供。根据《中华人民共和国民法典》规定，数据电文是合法的合同表现形式，与纸质合同具有同样的法律效力。
							<br />
							8、
							<span class="red-bold">本保险提供电子发票。</span>
							<br />
							9、
							<span class="red-bold">
								本保险由博维保险经纪有限公司面向全国销售并提供服务，如有其他疑问，请在投保前联系客服热线400-180-1616进行咨询与确认。
							</span>
							<br />
							10、
							<span class="red-bold">保单未到期前，</span>
							如被保险人未有员工出险，则保险人收取
							<span class="red-bold">保单约定</span>
							最低保费后，允许保单退保，并退还
							<span class="red-bold">未满期净保费</span>
							。最低保费标准：截止被保险人书面提出退保申请之日，生效不超15天（含）的按照半个月保费收费，生效超过15天且不足一个月的按照一个月保费收费。
							<br />
						</p>
						<el-divider></el-divider>
						<h3>特别约定</h3>

						<p style="line-height: 32px; white-space: pre-line">
							1、
							<span class="red-bold">
								本保单被保险人应在保险事故发生后 48 小时内报案，如超出
								48小时报案导致保险人无法核实事故真实情况，则保险人有权拒赔。如果被保险人超过72小时才报案，则保险人对按保单约定的应承担的保险责任，
							</span>
							扣除绝对免赔50%后赔付。 2、
							<span class="red-bold">出险后，被保险人必须在72小时内报案，报案服务咨询可拨打本保单</span>
							400-180-1616或太平洋产险全国统一客服电话95500，
							<span class="red-bold">
								取得报案号后才是报案成功（否则报案失败）。如果被保险人委托第三人/第三方报案，事后被保险人必须及时联系第三人/第三方，获取报案号。否则因第三人/第三方延迟报案，导致保险人按本保单第1条特别约定扣除免赔，那么被保险人须自行承担相关损失。
							</span>
							3、本保单被保险人雇员为电梯安装、维修保养人员，投保年龄限16-65周岁（含），与被保险人签订有劳动合同或存在事实劳动关系，接受被保险人给付薪金、工资，包括正式在册职工、短期工、临时工、季节工和徒工等相关工作人员。本保单采用记名承保，投保人数不少于3人。
							4、本保单仅承保以下工种（含高处作业）：电梯安装工、电梯维修保养工(含立体车库工程人员）。
							5、本保单不可减人，可加人。保单可换人，已出险人员不得批减、替换、退保。
							<span class="red-bold">
								保险期限1-3个月（含）的保单不可换人，保险期限超过3个月的保单可以换人，换人规则：电梯安装维修人员可替换为新的电梯安装维修人员。
							</span>
							6、本保单批增按以下年单保费的比例进行收费：不足一个月按一个月收费。
							<avue-crud :data="dataAddFeeRate" :option="optionAddFeeRate" style="padding: 10px"></avue-crud>
							7、保单未到期前，如被保险人未有员工出险，则保险人收取保单约定最低保费后，允许保单退保，并退还未满期净保费。最低保费标准：截止被保险人书面提出退保申请之日，生效不超15天（含）的按照半个月保费收费，生效超过15天且不足一个月的按照一个月保费收费。
							8、
							<span class="red-bold">
								本保单仅承保电梯安装维修行业人员（含高处作业、含立体车库工程人员）。本保单承保的电梯工程如家用电梯、商业楼宇和旧楼改造的载人载货电梯、自动手扶梯、自动人行道的电梯安装、维修工程和立体车库工程。具体承保工种为：电梯安装维保工。本产品可承保工种以太保职业分类表为准，本保单雇员投保的工种以保单的雇员清单为准。
							</span>
							9、
							<span class="red-bold">
								本保单只承保在进行电梯安装维修、立体车库工程施工中发生的保险事故，进行其他施工过程中发生的保险事故为除外责任。
							</span>
							10、
							<span class="red-bold">
								本保单不承保电梯安装前的工程（如土建工程、钢结构工程、幕墙安装工程）、电梯拆除工程、工地升降机安装维修工程。如施工合同中的项目名称含有保险人不承保的工程字眼，如“钢结构”、“电梯拆除”等或施工项目包含钢结构相关作业、电梯拆除作业等保险人不承保的工程作业，保险人不承担该保单的任何赔偿责任。
							</span>
							11、本保单指定就诊医院为大陆境内二级及以上公立医院，如因危及生命的紧急抢救（达到住院标准）无法前往本保单指定就诊医院的，经急救、情况基本稳定后72小时内，须转入本保单指定就诊医院治疗。
							12、在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡（雇员因疾病（包括职业病）、分娩、流产以及因上述原因接受医疗救治的不在该特约责任范围内），保险人承担赔偿责任，赔付金额=每人身故赔偿限额*20%。
							13、在保险期间内，被保险人的在保员工在受雇过程中因从事被保险人所安排的企业经营范围内的
							<span class="red-bold">电梯安装维修、立体车库工程工作</span>
							（不限电梯品牌、品类）而遭受意外事故（包括上下班途中遭受意外事故），或患与业务有关的国家规定的职业性疾病，所致伤、残或死亡，依照中华人民共和国法律应由被保险人承担的经济赔偿责任，保险人按照保险合同约定在赔偿限额内负责赔偿。
							14、在上下班途中，受到非员工本人主要责任的交通事故或者城市轨道交通、客运轮渡、火车事故伤害的，属于保险责任。
							15、在保险期间内，发生保险责任范围内的意外事故，保险人按下列标准赔偿：
							死亡：依据国家规定的工伤死亡赔偿标准计算，并在保单约定的死亡赔偿限额内赔偿。
							伤残：按伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的《劳动能力鉴定职工工伤与职业病致残等级》（GB/T16180-2014）确定伤残等级而支付相应赔偿金，伤残程度：永久丧失工作能力或一级伤残给付比例100%，二级伤残给付比例90%，三级伤残
							给付比例80%，四级伤残给付比例70%，五级伤残给付比例60%，六级伤残给付比例40%，七级伤残给付比例30%，八级伤残给付比例15%，九级伤残给付比例7%，十级伤残给付比例5%。
							16、医疗费用:本保单所约定的医疗费用赔偿责任仅包含在本保单认可的医疗机构发生且被保险人实际支出的，符合就诊地社会医疗保险主管部门规定的必要、合理、可报销的医疗费用，但不包括受伤人员的陪护费、伙食费、营养费、交通费、取暖费、空调费及安装假肢、假牙、假眼和残疾用具费用。每次医疗费用在社保用药内100%比例赔付。
							17、自费药：医疗费用如有其他第三方先行赔付的，本保险医疗费用项下扩展自费药；如医药费用无其他第三方先行赔付的，则本保单不予扩展赔付自费药：
							（1）每次事故赔偿限额为2000元； （2）我司和第三方赔付金额合计不超过医疗费发票总额；
							（3）每次事故自费药赔付金额不超过第三方赔付的医疗费用金额；
							（4）自费药为超出被保险人职员所在地工伤保险和基本医疗保险诊疗项目目录、药品
							目录、医疗服务设施范围和支付标准的合理且必要的医疗费用。
							18、误工费用：误工费用适用独立的赔偿限额，不包含在身故、伤残及医疗费用赔偿限额之内。按100元/天的标准赔偿误工费，免赔天数0天，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算仅依据住院期间、出院后的休息误工期间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GAT1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且自伤残鉴定结果日期起停止误工费的计算。被保险人雇员仅接受门诊治疗的，无误工费赔付。
							19、电梯安装、电梯维修保养过程中从事高处作业必须配带安全带、安全帽，孔洞须加强围栏或防滑措施。出险时如未系绑安全带导致发生身故或伤残事故，保险人对按保单约定的应承担的保险责任，扣除绝对免赔25%后赔付。
							20、
							<span class="red-bold">
								电梯安装人员须经过岗前安全培训，合格后方可上岗,发生伤残和死亡时须提供企业培训记录；电梯维保工作人员发生伤残和死亡时须提供电梯修理T证（由市场监督管理局或质量技术监督局颁发），否则保险人对按保单约定的应承担的保险责任，扣除绝对免赔25%后赔付。
							</span>
							21、本保单不承担任何性质的精神损害赔偿责任。
							22、兹经合同双方同意，因保险合同纠纷提起的诉讼，由被告住所所在地的人民法院管辖。 23、
							<span class="red-bold">
								如您不幸发生事故，或需要咨询保险相关事宜，请及时拨打服务热线：400-180-1616，获取工作人员的帮助。
							</span>
							24、
							<span class="red-bold">太平洋产险全国统一客户投诉电话：95500语音提示或按＃号键-3-2-4。</span>
						</p>
					</el-col>
				</el-row>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import {handleDownCategoryFile} from '@/util/util'
import {currentYYYYmmdd} from '@/util/date'
import {optionAddFeeRate, optionBenefit, optionPlan} from '@/const/crud/insurance/productDetail'

export default {
	name: 'Product45Details',
	props: {
		productId: {
			type: String | Number,
			required: true,
		},
	},
	data: function () {
		return {
			currentStep: '0',
			optionPlan: optionPlan,
			optionBenefit: optionBenefit,
			optionAddFeeRate: this.deepClone(optionAddFeeRate),
			dataPlan: [
				{
					insuredItem: '身故/伤残',
					plan1: '50万',
					plan2: '80万',
					plan3: '100万',
					plan4: '120万',
					plan5: '150万',
				},
				{
					insuredItem: '医疗费用 | 限社保用药',
					plan1: '5万',
					plan2: '8万',
					plan3: '10万',
					plan4: '10万',
					plan5: '12万',
				},
				{
					insuredItem: '误工费用',
					plan1: '无免赔，100元/天/上限180天,每次90天',
				},
				{
					insuredItem: '法律费用',
					plan1: '20万',
				},
				{
					insuredItem: '电梯安装维保工人年保费(元)',
					plan1: '720',
					plan2: '960',
					plan3: '1260',
					plan4: '1380',
					plan5: '1720',
				},
				{
					insuredItem: '1个月(元)',
					plan1: '144',
					plan2: '192',
					plan3: '252',
					plan4: '276',
					plan5: '344',
				},
				{
					insuredItem: '3个月(元)',
					plan1: '252',
					plan2: '336',
					plan3: '441',
					plan4: '483',
					plan5: '602',
				},
				{
					insuredItem: '6个月(元)',
					plan1: '468',
					plan2: '624',
					plan3: '819',
					plan4: '897',
					plan5: '1118',
				},
				{
					insuredItem: `本方案可投保1个月、3个月、6个月、12个月保险期限<br> 1个月保费=年单保费*20%、3个月保费=年单保费*35% 、6个月保费=年单保费*65%`,
				},
			],
			dataBenefit: [
				{
					levelItem: '比例',
					level10: '5%',
					level9: '7%',
					level8: '15%',
					level7: '30%',
					level6: '40%',
					level5: '60%',
					level4: '70%',
					level3: '80%',
					level2: '90%',
					level1: '100%',
				},
			],
			dataAddFeeRate: [
				{
					category: '比例',
					month1: '20%',
					month2: '25%',
					month3: '35%',
					month4: '45%',
					month5: '55%',
					month6: '65%',
					month7: '75%',
					month8: '80%',
					month9: '85%',
					month10: '90%',
					month11: '95%',
				},
			],
			dataPremiumRestrict: [
				{
					insuredTerm: '投保收费规则',
				},
				{
					insuredTerm: '1个月',
					term: 1,
				},
				{
					insuredTerm: '3个月',
					term: 3,
				},
				{
					insuredTerm: '6个月',
					term: 6,
				},
				{
					insuredTerm: '批增收费规则',
				},
				{
					insuredTerm: '2个月',
					term: 2,
				},
				{
					insuredTerm: '4个月',
					term: 4,
				},
				{
					insuredTerm: '5个月',
					term: 5,
				},
			],
			dataQA: [
				{
					question: '哪些职业可保？',
					answer: '本产品只保障电梯行业电梯安装、维保人员。',
				},
				{
					question: '哪些职业不可保？',
					answer:
						'本产品只保障电梯行业电梯安装、维保人员，不慎投保，请及时联系客服人员退保。若需要投保其他行业，请联系客服人员。',
				},
				{
					question: '如果从事高处作业，但是无安全带或者无高处作业证，保险公司是否拒赔？',
					answer:
						'电梯安装、电梯维修保养过程中从事高处作业必须配带安全带、安全帽，孔洞须加强围栏或防滑措施。出险时如未系绑安全带导致发生身故或伤残事故，会有免赔，但不拒赔。\n' +
						'电梯维保工人需持有电梯操作证，电梯安装工人需要通过岗前培训通过证明文件，会有免赔，但不拒赔。',
				},
				{
					question: '雇员变动怎么办？',
					answer: '',
				},
			],
			isDownLoading: false,
		}
	},
	created() {
		let categoryTemp = this.findObject(this.optionAddFeeRate.column, 'category')
		categoryTemp.hide = true
	},
	methods: {
		spanMethodPlan({row, column, rowIndex, columnIndex}) {
			if (rowIndex === 8) {
				if (columnIndex === 0) {
					return [1, 11]
				}
			}
			if (rowIndex === 2 || rowIndex === 3) {
				if (columnIndex === 1) {
					return [1, 6]
				}
			}
		},
		spanMethodPremium({row, column, rowIndex, columnIndex}) {
			if (rowIndex === 0 || rowIndex === 4) {
				if (columnIndex === 0) {
					return [1, 11]
				}
			}
		},
		spanMethodPremiumRestrict({row, column, rowIndex, columnIndex}) {
			if (rowIndex === 0 || rowIndex === 4) {
				if (columnIndex === 0) {
					return [1, 6]
				}
			}
		},
		onCellStyle({row, column}) {
			if (row.$index === 8) {
				return {
					padding: '10px',
					fontSize: '14px',
					fontWeight: 'bold',
				}
			}
		},
		onCellStyleFit({row, column, rowIndex, columnIndex}) {
			if (columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 4 || columnIndex === 5) {
				return {
					color: 'red',
				}
			}
		},
		handleInsure(type) {
			this.$emit('insure', type)
		},
		handleDownLoad() {
			this.isDownLoading = true
			let fileName = `fgk_${this.productId}_template_chinalife_${currentYYYYmmdd()}.xlsx`
			handleDownCategoryFile(
				`/dist/distInsure/categoryDownloadDetail
/${this.productId}`,
				{},
				fileName,
			)
				.then(() => {
					//下载成功
				})
				.finally(() => {
					this.isDownLoading = false
				})
		},
	},
}
</script>

<style lang="scss" scoped>
.red-bold {
	font-weight: bold;
	color: red;
}

.el-col {
	font-size: 14px;
}

.el-card {
	font-size: 14px;
	margin-bottom: 16px;
}

.item {
	margin-bottom: 18px;
}

.ul,
li {
	list-style: none;
}

span.link {
	display: block;
	text-indent: 1em;
}

h2 {
	margin: 0px;
	padding: 0px;
}
</style>
